import { render, staticRenderFns } from "./AdminProfitIndexPageTableRow.vue?vue&type=template&id=1ba1f12c&"
import script from "./AdminProfitIndexPageTableRow.vue?vue&type=script&lang=ts&"
export * from "./AdminProfitIndexPageTableRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports